export const parseRemoteComments = comment => {
  const fixedComment = comment[0] === '"' ? JSON.parse(comment) : comment;
  const notes = fixedComment.split('Notes:');
  if (notes[1]) return notes[1].trim();
  return comment;
};
